module.exports = __webpack_public_path__ + "static/img/banner-shop.b0b86bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/banner-shop.jpg
// module id = VZHZ
// module chunks = 1